import request from '@/utils/request'

export function login(username, password, captcha) {
  return request({
    url: '/user/login',
    method: 'post',
    data: {
      username,
      password,
      captcha
    }
  })
}

export function getInfo() {
  return request({
    url: '/user/infoDetail',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

// 邮箱登录
export function energyLoginWithMail(data) {
  return request({
    url: '/user/loginWithMail',
    method: 'post',
    data: data,
  })
}

// TG登录
export function energyLoginWithTG(data) {
  return request({
    url: '/user/loginWithTG',
    method: 'post',
    data: data,
  })
}

// TG miniApp登录
export function loginWithTGMiniApp(data) {
  return request({
    url: '/user/loginWithTGMiniApp',
    method: 'post',
    data: data,
  })
}

// 获取当前登录用户信息
export function energyUserNameList(params) {
  return request({
    url: '/user/me',
    method: 'get',
    params: params,
  })
}

// 登出功能
export function energyLogout(data) {
  return request({
    url: '/user/logout',
    method: 'post',
    data: data,
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js